import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SportsTitleCasePipe } from "@sports-pipes/index";
import { SportHandleList } from "@sports-utils/sport-handle-list";
import { sportsLiterals } from "@sports-utils/sports.constants";

@Component({
  selector: "sb-live-scoreboard-sets",
  templateUrl: "./sb-live-scoreboard-sets.html",
  styleUrls: ["./sb-live-scoreboard-sets.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, SportsTitleCasePipe],
})
export class SbLiveScoreboardSetsComponent {
  @Input() match: any;
  matchPeriod: string;
  matchTime: string;
  sport: string;
  quarter: any = 0;
  currentPeriod: number;
  MAX_LENGTH: number;

  ngOnChanges() {
    this.sport = this.match.SportHandle;
    this.quarter = this.match.Quarters;
    this.MAX_LENGTH = this.sport === SportHandleList.ice_hockey ? 3 : 4;

    if (this.sport === SportHandleList.soccer) {
      this.setCorners();
    }
    this.setPeriod();
    this.setTime();
    this.parseTennisAD();
    if (this.mustFillEmptyPeriods) {
      this.fill();
    }
  }

  get set(): boolean {
    return (
      this.sport === SportHandleList.tennis ||
      this.sport === SportHandleList.table_tennis ||
      this.sport === SportHandleList.beach_volleyball ||
      this.sport === SportHandleList.volleyball
    );
  }

  get time(): boolean {
    return this.sport === SportHandleList.darts;
  }

  get period(): boolean {
    return this.sport === SportHandleList.ice_hockey;
  }

  get periodAndTime(): boolean {
    return (
      this.sport === SportHandleList.american_football ||
      this.sport === SportHandleList.basketball ||
      this.sport === SportHandleList.soccer
    );
  }

  get attack(): boolean {
    return this.sport === SportHandleList.american_football;
  }

  get service(): boolean {
    return (
      this.sport === SportHandleList.badminton ||
      this.sport === SportHandleList.tennis ||
      this.sport === SportHandleList.table_tennis ||
      this.sport === SportHandleList.tennis_clay ||
      this.sport === SportHandleList.tennis_grass ||
      this.sport === SportHandleList.tennis_indoor ||
      this.sport === SportHandleList.beach_volleyball ||
      this.sport === SportHandleList.volleyball
    );
  }

  get points(): boolean {
    return this.sport === SportHandleList.tennis;
  }

  get yellowCards(): boolean {
    return this.sport === SportHandleList.soccer;
  }

  get redCards(): boolean {
    return this.sport === SportHandleList.soccer;
  }

  get corners(): boolean {
    return this.sport === SportHandleList.soccer;
  }

  get totalScore(): boolean {
    return this.sport !== "tennis";
  }

  get mustFillEmptyPeriods() {
    return (
      this.sport === SportHandleList.basketball ||
      this.sport === SportHandleList.ice_hockey ||
      this.sport === SportHandleList.american_football
    );
  }

  get halfTime(): boolean {
    return (
      this.match.RemainingPeriodTime === sportsLiterals.RemainingPeriodTimeNull ||
      this.match.PeriodName === sportsLiterals.Descanso
    );
  }

  private setCorners() {
    this.match = {
      ...this.match,
      homeCorners: this.match.Actions.reduce((acc, action) => {
        if (action.ActionType === 1 && action.IsHomeTeam) {
          acc += 1;
        }
        return acc;
      }, 0),
      awayCorners: this.match.Actions.reduce((acc, action) => {
        if (action.ActionType === 1 && !action.IsHomeTeam) {
          acc += 1;
        }
        return acc;
      }, 0),
    };
  }

  private setPeriod() {
    this.matchPeriod = this.match.PeriodName;
  }

  private setTime() {
    if (this.match.RemainingPeriodTime) {
      this.matchTime = this.halfTime ? "" : "< " + this.match.RemainingPeriodTime;
      return;
    }

    if (this.match.MatchTime) {
      this.matchTime =
        this.match.MatchTime === -1 || this.match.PeriodName === sportsLiterals.Descanso
          ? ""
          : this.match.MatchTime + "'";
    }
  }

  private fill() {
    const property = this.getPeriodProperty();
    this.currentPeriod = this.match[property].length;

    if (this.match[property].length < this.MAX_LENGTH) {
      const blank = ["-", "-"];
      let fill = this.MAX_LENGTH - this.match[property].length;
      const newMatch = { ...this.match };
      while (fill > 0) {
        newMatch[property] = [...newMatch[property], blank];
        fill--;
      }
      this.match = { ...newMatch };
    }
  }

  private getPeriodProperty(): string {
    const quarters = Array.isArray(this.match.Quarters) ? "Quarters" : null;
    const periods = Array.isArray(this.match.Periods) ? "Periods" : null;
    return quarters || periods;
  }

  private parseTennisAD() {
    if (this.sport !== "tennis") {
      return;
    }
    this.match = {
      ...this.match,
      ResultHome: this.match.ResultHome === 50 ? "AD" : this.match.ResultHome,
      ResultAway: this.match.ResultAway === 50 ? "AD" : this.match.ResultAway,
    };
  }

  setGameState(game, set, last, index) {
    if (last && this.halfTime) {
      return "color-score";
    }

    if (last) {
      return "color-light";
    }

    const op = index === 0 ? 1 : 0;
    return game < set[op] ? "color-score" : "color-light";
  }
}
